
export enum CompanyLogoSize {
    SIZE_18     = '18', // New. Experimental
    SIZE_22     = '22',
    SIZE_32     = '32',
    SIZE_80     = '80',
    SIZE_100    = '100'
}
